/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="140" height="140" {...props}>
    <path
      fill="#fff"
      d="M63.436 26.222C63.436 17.26 56.178 10 47.218 10s-16.202 7.26-16.202 16.222c0 8.963 7.258 16.223 16.202 16.223 8.96 0 16.218-7.277 16.218-16.223zm21.691 18.225c-8.443 0-15.284 6.843-15.284 15.288S76.684 75.04 85.127 75.04c8.443 0 15.301-6.843 15.301-15.305 0-8.428-6.841-15.288-15.3-15.288z"
    ></path>
    <path
      fill="#fff"
      d="M120.618 111.773h-8.26l-.033-10.798c0-3.455-.367-6.409-1.068-8.912a12.992 12.992 0 01-5.423 1.185c-3.12 0-6.057-1.068-8.526-3.088-3.087-2.52-4.623-6.225-4.522-10.147H75.833c-11.697.768-17.904 6.61-17.904 20.962l-.034 10.798h-4.639l.034-10.798c0-15.12 6.674-23.632 19.84-25.351-4.806-3.639-7.926-9.397-7.926-15.872 0-3.655 1-7.06 2.72-10.014-2.887-1.77-6.508-2.737-10.863-3.02L47.2 54.51l-9.862-7.794c-12.398.801-18.972 7.01-18.972 22.214l.017 31.076c0 4.74 3.387 8.512 9.644 8.512v3.254h-9.66v4.64h42.882v2.103H59.28c-.65 0-1.268.317-1.635.851a1.95 1.95 0 00-.234 1.836l2.92 8.044a2.004 2.004 0 001.886 1.319h45.836c.851 0 1.602-.534 1.886-1.319l2.92-8.044a2.046 2.046 0 00-.234-1.836 1.986 1.986 0 00-1.635-.851h-1.969v-2.103h11.613v-4.64h-.016zm-15.285 15.238H64.937v-24.968c0-.851.7-1.535 1.552-1.535h37.309c.851 0 1.552.701 1.552 1.535v24.968h-.017z"
    ></path>
    <path
      fill="#fff"
      d="M85.144 111.539a3.134 3.134 0 00-3.137 3.138 3.13 3.13 0 003.137 3.121 3.116 3.116 0 003.12-3.121 3.13 3.13 0 00-3.12-3.138zm15.082-24.984a8.895 8.895 0 005.59 2.037c2.453.016 4.955-.918 7.041-4.256 2.72-4.356.267-6.242-3.32-9.246-2.286-1.92-4.439-3.672-6.424-3.655-1.836.016-2.87 1.568-3.922 3.17-2.52 3.84-2.586 8.996 1.035 11.95z"
    ></path>
  </Svg>
)

export default Icon
